import { Icon, TextButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type IntercomFeedbackSurveyIdsEnum } from './IntercomFeedbackSurveyIdsEnum'
import messages from './messages'
import { useIntercomShareFeedbackButtonPresenter } from './useIntercomShareFeedbackButtonPresenter'

interface IIntercomShareFeedbackButtonPresenterProps {
  surveyId: IntercomFeedbackSurveyIdsEnum
}

export const IntercomShareFeedbackButtonPresenter = ({
  surveyId,
}: IIntercomShareFeedbackButtonPresenterProps) => {
  const intl = useProcurifyIntl()
  const {
    states: { isIntercomEnabled },
    commands: { openIntercomFeedbackSurvey },
  } = useIntercomShareFeedbackButtonPresenter({ surveyId })

  if (!isIntercomEnabled) {
    return null
  }

  return (
    <TextButton onClick={openIntercomFeedbackSurvey}>
      <Icon icon='message' />
      &nbsp;{intl.formatMessage(messages.shareFeedback)}
    </TextButton>
  )
}
